const Contract = function Contract() {
  // const errorHandler =
  //   _errorHandler ||
  //   ((error) => {
  //     console.log(error)
  //   })
}

export default Contract
